import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import Vue from "vue";

export async function loadData(devices, {chart}, dateRange, dataType, otherLang) {
    chart.showLoading();

    while (chart.series[0].options._levelNumber > 0) {
      chart.drillUp();
    }

    chart.series[0].setData([], false, false, false);
    chart.series[0].update({ name: devices.title });

    if (devices.children) {
      let chunkEnergy = 0;
      let sumEnergy = 0;

      for (let idx = 0; idx < devices.children.length; idx++) {
        if (devices.children[idx].isLeaf) {
          if (devices.children[idx].data.report_mode === 1) {
            await getAPIData(devices.children[idx].data.mac, dateRange, dataType).then(
              response => {
                if (response > 0) {
                  chunkEnergy += response;

                  chart.series[0].addPoint({
                    name: devices.children[idx].title,
                    y: response,
                    visible: true
                  });
                }
              }
            );
          } else if (devices.children[idx].data.report_mode === 2) {
            await getAPIData(devices.children[idx].data.mac, dateRange, dataType).then(
              response => {
                if (response > 0) {
                  sumEnergy += response;
                }
              }
            );
          }
        } else {
          await getDevicesEnergy(devices.children[idx], dateRange, dataType, otherLang).then(
            response => {
              if (response.totalEnergy > 0) {
                chunkEnergy += response.totalEnergy;

                chart.series[0].addPoint(
                  {
                    name: devices.children[idx].title,
                    y: response.totalEnergy,
                    drilldown: devices.children[idx].title
                  },
                  false,
                  false,
                  false,
                  false
                );

                let drillDownBuffer = [];

                chart.userOptions.drilldown.series.forEach(element => {
                  drillDownBuffer.push(element);
                });

                response.drilldown.forEach(element => {
                  drillDownBuffer.push(element);
                });

                chart.update({
                  drilldown: {
                    series: drillDownBuffer
                  }
                });
              }
            }
          );
        }
      }

      if (sumEnergy > 0) {
        const otherEnergy = sumEnergy - chunkEnergy;

        if (otherEnergy > 0) {
          chart.series[0].addPoint({
            name: otherLang,
            y: otherEnergy,
            visible: true
          });
        }
      }

    }
};

function getAPIData(deviceMAC, dateRange, dataType) {
    return new Promise(async (resolve, reject) => {
      axios({
        method: "POST",
        url: Vue.prototype.$ENDPOINTS.API_R + "/energy",
        data: {
          token: getSelectedDeviceToken(deviceMAC),
          data: dataType,
          phase: "CUM",
          from: dateRange.from,
          to: dateRange.to,
          source: 1
        },
        withCredentials: true
      })
        .then(response => {
          resolve(response.data.data[0][dataType].CUM);
        })
        .catch(error => {
          resolve(0);
          if (error.response) {
            // this.$refs.snackbar.notify(
            //   this.$lang.messages.api_communication_error
            // );
          }
        });
    });
};

function getDevicesEnergy(devicesList, dateRange, dataType, otherLang) {
    return new Promise(async (resolve, reject) => {
      if (devicesList.children) {
        let totalEnergy = 0;
        let drillDown = [
          {
            name: devicesList.title,
            id: devicesList.title,
            data: []
          }
        ];

        let chunkEnergy = 0;
        let sumEnergy = 0;

        for (let idx = 0; idx < devicesList.children.length; idx++) {
          if (devicesList.children[idx].isLeaf) {
            if (devicesList.children[idx].data.report_mode === 1) {
              await getAPIData(devicesList.children[idx].data.mac, dateRange, dataType).then(
                response => {
                  if (response > 0) {
                    totalEnergy += response;
                    chunkEnergy += response;

                    drillDown[0].data.push({
                      name: devicesList.children[idx].title,
                      y: response
                    });
                  }
                }
              );
            } else if (devicesList.children[idx].data.report_mode === 2) {
              await getAPIData(devicesList.children[idx].data.mac, dateRange, dataType).then(
                response => {
                  if (response > 0) {
                    sumEnergy += response;
                  }
                }
              );
            }
          } else {
            await getDevicesEnergy(devicesList.children[idx], dateRange, dataType, otherLang).then(
              response => {
                totalEnergy += response.totalEnergy;

                response.drilldown.forEach(element => {
                  drillDown.push(element);
                });

                drillDown[0].data.push({
                  name: devicesList.children[idx].title,
                  y: response.totalEnergy,
                  drilldown: devicesList.children[idx].title
                });
              }
            );
          }
        }

        if (sumEnergy > 0) {
          totalEnergy = sumEnergy;
          const otherEnergy = sumEnergy - chunkEnergy;

          if (otherEnergy > 0) {
            drillDown[0].data.push({
              name: otherLang,
              y: otherEnergy
            });
          }
        }

        resolve({
          totalEnergy: totalEnergy,
          drilldown: drillDown
        });
      }
    });
  };